import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { BatchFieldReadHelper } from '../../../../helpers/fields/batch-field-read.helper';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShBaseGenericInputFieldComponent } from '../../base-generic-input-field/base-generic-input-field.component';

@Component({
    standalone: false,
    selector: 'sh-simple-input-field',
    templateUrl: './simple-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShSimpleInputFieldComponent extends ShBaseGenericInputFieldComponent {
    constructor(protected fieldHelper: FieldReadHelper) {
        super();
    }

    init(profileField: ExtendedBaseProfileField, records: PartialRecord[], control: UntypedFormControl): void {
        const value = this.isBatchEdit
            ? BatchFieldReadHelper.getBatchFieldValue(profileField.FieldDefinition)
            : this.fieldHelper.getMergedSimpleFieldValue(profileField.FieldDefinition, records);
        control.setValue(value);
    }
}
